module.exports = __webpack_public_path__ + "assets/img/examineWaiting.850b7345.png";